import { useState } from 'react'

import {
  FetchElementAuthorizationsInvite,
  RemoveInviteAuthorization,
  RemoveInviteAuthorizationVariables,
} from 'globalTypes'

import { gql, useMutation } from '@apollo/client'
import { Trans } from '@lingui/macro'
import AskUserConfirmation from 'Root/App/Dialog/ask-user-confirmation'

import RemoveButton from '../remove-button'
import RemoveUserAuthorizationAlert from '../remove-user-auth-alert'
import LevelButton from './LevelButton'

interface Props {
  elementId: string
  invite: FetchElementAuthorizationsInvite
}

const REMOVE_INVITE_AUTHORIZATION = gql`
  mutation RemoveInviteAuthorization($elementId: ID!, $email: Email!) {
    removeInviteAuthorization(elementId: $elementId, email: $email)
  }
`

const Invite = ({ elementId, invite }: Props) => {
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false)
  const [mutate, { loading }] = useMutation<
    RemoveInviteAuthorization,
    RemoveInviteAuthorizationVariables
  >(REMOVE_INVITE_AUTHORIZATION, {
    refetchQueries: ['GetElementAuthorizationForUsers'],
  })

  const handleInviteRemove = async () => {
    await mutate({
      variables: {
        email: invite.id,
        elementId,
      },
    })

    setOpenRemoveDialog((openDialog) => !openDialog)
  }

  const onCloseFn = !loading
    ? () => setOpenRemoveDialog((openRemoveDialog) => !openRemoveDialog)
    : () => null

  return (
    <div
      className="flex flex-col justify-between gap-3 p-3 sm:flex-row sm:gap-1"
      key={invite.id}
      role="listitem"
    >
      <div className="flex-grow flex flex-col my-auto text-sm text-gray-600">
        <div className="font-medium">{invite.id}</div>
        <div className="italic text-gray-400">
          <Trans>Indirizzo email non confermato.</Trans>
        </div>
      </div>
      <div className="flex flex-row gap-1 sm:flex-nowrap items-center">
        <LevelButton
          elementId={elementId}
          email={invite.id}
          level={invite.authorization}
        />
        <RemoveButton onRemoveCallback={handleInviteRemove} />
      </div>
      {openRemoveDialog && (
        <AskUserConfirmation openDialog={openRemoveDialog} onClose={onCloseFn}>
          <RemoveUserAuthorizationAlert
            onConfirm={handleInviteRemove}
            onClose={onCloseFn}
            isRemoving={loading}
          />
        </AskUserConfirmation>
      )}
    </div>
  )
}

export default Invite
